import React, { ReactNode } from 'react';
import { useFormikContext } from 'formik';

import Button from '@components/Button';

interface IProps {
  children: ReactNode | ReactNode[];
}

function FormSubmitButton({ children }: IProps) {
  const { submitForm, isSubmitting, isValid, touched } = useFormikContext();

  return (
    <Button
      type="submit"
      isLoading={isSubmitting}
      disabled={!isValid || Object.keys(touched).length === 0}
      onClick={submitForm}>
      {children}
    </Button>
  );
}

export default FormSubmitButton;
